'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getToggleStyleFunc = require('./getToggleStyleFunc');

var _getToggleStyleFunc2 = _interopRequireDefault(_getToggleStyleFunc);

var _getToggleBlockStyleFunc = require('./getToggleBlockStyleFunc');

var _getToggleBlockStyleFunc2 = _interopRequireDefault(_getToggleBlockStyleFunc);

var _getCurrentInlineStyle = require('./getCurrentInlineStyle');

var _getCurrentInlineStyle2 = _interopRequireDefault(_getCurrentInlineStyle);

var _getCurrentEntity = require('./getCurrentEntity');

var _getCurrentEntity2 = _interopRequireDefault(_getCurrentEntity);

var _getSelectedBlock = require('./getSelectedBlock');

var _getSelectedBlock2 = _interopRequireDefault(_getSelectedBlock);

var _getEntitySelectionState = require('./getEntitySelectionState');

var _getEntitySelectionState2 = _interopRequireDefault(_getEntitySelectionState);

var _findEntity = require('./findEntity');

var _findEntity2 = _interopRequireDefault(_findEntity);

var _getSelectedText = require('./getSelectedText');

var _getSelectedText2 = _interopRequireDefault(_getSelectedText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var EditorUtils = {
    getToggleStyleFunc: _getToggleStyleFunc2["default"],
    getToggleBlockStyleFunc: _getToggleBlockStyleFunc2["default"],
    getCurrentInlineStyle: _getCurrentInlineStyle2["default"],
    getCurrentEntity: _getCurrentEntity2["default"],
    getSelectedBlock: _getSelectedBlock2["default"],
    getEntitySelectionState: _getEntitySelectionState2["default"],
    findEntity: _findEntity2["default"],
    getSelectedText: _getSelectedText2["default"]
};
exports["default"] = EditorUtils;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-editor-utils@0.1.0@rc-editor-utils/lib/EditorUtils.js
// module id = 114
// module chunks = 0 1 2